import CheckIcon from "@mui/icons-material/Check";
import { Box, Button, Typography } from "@mui/material";
import { useContext, useRef } from "react";
import { useHistory } from "react-router-dom";
import appContext from "../../context/context";
import Container from "../Common/Container";
import ListItem from "../Common/ListItem";
import Info from "./Info";
import Product from "./Product";
const Order = () => {
  const {
    state: { orderProductQuantity, singleProduct },
    handleSubmitOrderBicycle,
  } = useContext(appContext);
  const fullNameRef = useRef();
  const addressRef = useRef();
  const phoneRef = useRef();
  const emailRef = useRef();
  const getValue = (x) => x.current.value;
  const clearValue = (x) => (x.current.value = "");
  const history = useHistory();
  const handleSubmit = (e) => {
    e.preventDefault();
    handleSubmitOrderBicycle(
      {
        fullname: getValue(fullNameRef),
        address: getValue(addressRef),
        phone: getValue(phoneRef),
        email: getValue(emailRef),
        product: singleProduct._id,
        quantity: orderProductQuantity,
      },
      history
    );

    clearValue(addressRef);
    clearValue(phoneRef);
  };

  return (
    <Container>
      <Box component="form" onSubmit={handleSubmit}>
        <Product />
        <Typography variant="h5" color="var(--primary)" py="0.5rem">
          Your Detail
        </Typography>

        <Info
          fullNameRef={fullNameRef}
          addressRef={addressRef}
          phoneRef={phoneRef}
          emailRef={emailRef}
        />
        <Typography variant="h5" color="var(--primary)" py="0.5rem">
          Order Detail
        </Typography>

        <ListItem name="Quantity" desc={orderProductQuantity} />
        <ListItem
          name="Total Price"
          desc={singleProduct?.price * orderProductQuantity + "$"}
        />
        <Box color="var(--secondary)">
          <Button
            type="submit"
            fullWidth
            variant="outlined"
            mx="0.5rem"
            color="inherit"
            startIcon={<CheckIcon />}
          >
            Confirm Order To Pay
          </Button>
        </Box>
      </Box>
    </Container>
  );
};
export default Order;
